import "./IconProvider.css";

function IconProvider(props: any) {
    return (
        <div className={props.size ? "icon " + props.size : "icon"}>
            <svg viewBox="0 0 200 200" width="100%" height="100%" preserveAspectRatio="none" className={props.color ? props.color : ""}>
                <use href={process.env.PUBLIC_URL + "/sprite.svg#" + props.id} />
            </svg>
        </div>
    )
}

export default IconProvider;

